// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3kRR3","top":"Footer_top__CRDFF","subscribe":"Footer_subscribe__2_4BO","bottom":"Footer_bottom__OMn3O","contact":"Footer_contact__3Gwe_"};